import { css } from 'linaria';

export const list = css`
  padding: 0 0 0 18px;
  margin: 0;

  li:not(:last-child) {
    margin-bottom: 12px;
  }

  li::marker {
    color: var(--text-primary);
  }
`;

export const customIcon = css`
  padding: 0;

  li {
    display: flex;
    align-items: center;
  }
`;
